module.exports = __webpack_public_path__ + "static/building-a4ff920a02e00278fecad8dcc9bbdefe.svg";